import React from 'react';
import './css/Home.css';

export const Home = () => {
  return (
    <div id="home" className="home-container">
      <h1 className="home-title">Hello, I'm Athena</h1>
      <h2 className="home-subtitle">Software Engineer & Full Stack Developer</h2>
    </div>
  );
};
